import { FC } from 'react'
import Modal from '@common/Modal'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'

type DiscardLeadDraftChangesModalProps = {
  open: boolean
  onDiscard: () => void
  onDiscardAndClose: () => void
  onDismiss: () => void
}

const DiscardLeadDraftChangesModal: FC<DiscardLeadDraftChangesModalProps> = ({
  open,
  onDiscard,
  onDiscardAndClose,
  onDismiss,
}) => (
  <Modal
    active={open}
    className={mclasses.confirmModalWrapper as any}
    setActive={() => onDismiss()}
  >
    <div className={mclasses.modalContainer}>
      <div className={mclasses.modalHeader}>
        <div className={mclasses.modalTitleContainer}>
          <span className={mclasses.modalHeaderTitle}>
            Несохранённые изменения
          </span>
        </div>
        <button
          type="button"
          className={mclasses.closeIcon}
          onClick={onDismiss}
          aria-label="Закрыть"
        >
          <IcoRemove />
        </button>
      </div>
      <div className={mclasses.formWrapper}>
        <p>
          Если в карточке лида есть несохранённые правки, можно сбросить их к
          последнему сохранённому состоянию или сбросить и закрыть карточку.
        </p>
        <p>Будут отменены локальные изменения:</p>
        <ul style={{ margin: '0.5em 0', paddingLeft: '1.25em' }}>
          <li>поля анкеты (включая файл и чекбоксы);</li>
          <li>менеджер, статус и дата следующего контакта;</li>
          <li>канал трафика;</li>
          <li>UTM-метки и комментарий сделки (если доступны).</li>
        </ul>
        <p>Данные на сервере не изменятся — только черновик в форме.</p>
      </div>
      <div className={mclasses.actions} style={{ flexWrap: 'wrap' }}>
        <Button color="gray" onClick={onDismiss}>
          Продолжить редактирование
        </Button>
        <Button color="gray" onClick={onDiscard}>
          Сбросить изменения
        </Button>
        <Button color="primary" onClick={onDiscardAndClose}>
          Сбросить и закрыть
        </Button>
      </div>
    </div>
  </Modal>
)

export default DiscardLeadDraftChangesModal
